import { Box, Flex, Heading, Text } from '@chakra-ui/react';
import { Fragment, FC } from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { Lounge } from './EventExampleSlides/Lounge';
import { MainStage } from './EventExampleSlides/MainStage';
import { Posters } from './EventExampleSlides/Posters';
import { Reception } from './EventExampleSlides/Reception';
import { Schedule } from './EventExampleSlides/Schedule';
import { Sessions } from './EventExampleSlides/Sesssions';
import { Sponsors } from './EventExampleSlides/Sponsors';
import { TabItemsLabels } from './eventExampleTabHelper';

interface IEventExampleTabContentProps {
  activeTab?: TabItemsLabels;
}

export const EventExampleTabContent: FC<IEventExampleTabContentProps> = ({ activeTab }) => {
  const { t } = useTranslation();

  const renderTabContent = () => {
    switch (activeTab) {
      case TabItemsLabels.eventMainStage:
        return (
          <Fragment>
            <Box flex={1} maxW={{ base: '100%', md: '248px', lg: '390px' }}>
              <Trans
                i18nKey="landing.eventMainStageContent.title"
                components={{
                  heading: <Heading as="h3" lineHeight={10} mb={10} fontSize="32px" />,
                  span: <Heading as="span" color="violet.500" lineHeight={10} fontSize="32px" />,
                  br: <br />,
                }}
              />

              <Text fontFamily="heading" m={0}>
                {t('landing.eventMainStageContent.virtualSpace')}
              </Text>
              <Text fontFamily="heading" m={0} mt={4}>
                {t('landing.eventMainStageContent.remote')}
              </Text>
            </Box>

            <Box flex={1} mt={{ base: 10, md: 0 }} ml={{ base: 0, md: '50px' }}>
              <MainStage />
            </Box>
          </Fragment>
        );

      case TabItemsLabels.eventSessions:
        return (
          <Fragment>
            <Box flex={1} maxW={{ base: '100%', md: '248px', lg: '390px' }}>
              <Trans
                i18nKey="landing.eventSessionsContent.title"
                components={{
                  heading: <Heading as="h3" lineHeight={10} mb={10} fontSize="32px" />,
                  span: <Heading as="span" color="violet.500" lineHeight={10} fontSize="32px" />,
                  br: <br />,
                }}
              />

              <Text fontFamily="heading" m={0}>
                {t('landing.eventSessionsContent.liveVideos')}
              </Text>
              <Text fontFamily="heading" m={0}>
                {t('landing.eventSessionsContent.sessions')}
              </Text>
            </Box>
            <Box flex={1} mt={{ base: 10, md: 0 }} ml={{ base: 0, md: '50px' }}>
              <Sessions />
            </Box>
          </Fragment>
        );

      case TabItemsLabels.eventPosters:
        return (
          <Fragment>
            <Box flex={1} maxW={{ base: '100%', md: '248px', lg: '390px' }}>
              <Trans
                i18nKey="landing.eventPostersContent.title"
                components={{
                  heading: <Heading as="h3" lineHeight={10} mb={10} fontSize="32px" />,
                  span: <Heading as="span" color="violet.500" lineHeight={10} fontSize="32px" />,
                  br: <br />,
                }}
              />

              <Text fontFamily="heading" m={0}>
                {t('landing.eventPostersContent.digitalExperience')}
              </Text>
              <Text fontFamily="heading" m={0}>
                {t('landing.eventPostersContent.virtualVenue')}
              </Text>
            </Box>

            <Box flex={1} mt={{ base: 10, md: 0 }} ml={{ base: 0, md: '50px' }} maxW="490px">
              <Posters />
            </Box>
          </Fragment>
        );

      case TabItemsLabels.eventReception:
        return (
          <Fragment>
            <Box flex={1} maxW={{ base: '100%', md: '248px', lg: '390px' }}>
              <Trans
                i18nKey="landing.eventReceptionContent.title"
                components={{
                  heading: <Heading as="h3" lineHeight={10} mb={10} fontSize="32px" />,
                  span: <Heading as="span" color="violet.500" lineHeight={10} fontSize="32px" />,
                  br: <br />,
                }}
              />

              <Text fontFamily="heading" m={0}>
                {t('landing.eventReceptionContent.attendees')}
              </Text>
              <Text fontFamily="heading" m={0}>
                {t('landing.eventReceptionContent.announce')}
              </Text>
            </Box>
            <Box flex={1} mt={{ base: 10, md: 0 }} ml={{ base: 0, md: '50px' }} maxW="490px">
              <Reception />
            </Box>
          </Fragment>
        );

      case TabItemsLabels.eventLounge:
        return (
          <Fragment>
            <Box flex={1} maxW={{ base: '100%', md: '248px', lg: '390px' }}>
              <Trans
                i18nKey="landing.eventLoungeContent.title"
                components={{
                  heading: <Heading as="h3" lineHeight={10} mb={10} fontSize="32px" />,
                  span: <Heading as="span" color="violet.500" lineHeight={10} fontSize="32px" />,
                  br: <br />,
                }}
              />

              <Text fontFamily="heading" m={0}>
                {t('landing.eventLoungeContent.socializing')}
              </Text>
              <Text fontFamily="heading" m={0}>
                {t('landing.eventLoungeContent.lounge')}
              </Text>
            </Box>

            <Box
              flex={1}
              mt={{ base: 10, md: 0 }}
              ml={{ base: 0, md: '50px' }}
              maxW={{ base: '350px', md: '390px', lg: '540px' }}
            >
              <Lounge />
            </Box>
          </Fragment>
        );

      case TabItemsLabels.eventSchedule:
        return (
          <Fragment>
            <Box flex={1} maxW={{ base: '100%', md: '248px', lg: '390px' }}>
              <Trans
                i18nKey="landing.eventScheduleContent.title"
                components={{
                  heading: <Heading as="h3" lineHeight={10} mb={10} fontSize="32px" />,
                  span: <Heading as="span" color="violet.500" lineHeight={10} fontSize="32px" />,
                  quote: <Heading as="q" color="violet.500" lineHeight={10} fontSize="32px" />,
                  br: <br />,
                }}
              />

              <Text fontFamily="heading" m={0}>
                {t('landing.eventScheduleContent.schedule')}
              </Text>
              <Text fontFamily="heading" m={0}>
                {t('landing.eventScheduleContent.calendarIntegration')}
              </Text>
            </Box>

            <Box
              flex={1}
              mt={{ base: 10, md: 0 }}
              ml={{ base: 0, md: '50px' }}
              maxW={{ base: '460px', md: '510px', lg: '610px' }}
            >
              <Schedule />
            </Box>
          </Fragment>
        );

      case TabItemsLabels.eventExpo:
        return (
          <Fragment>
            <Box flex={1} maxW={{ base: '100%', md: '248px', lg: '390px' }}>
              <Trans
                i18nKey="landing.eventExpoContent.title"
                components={{
                  heading: <Heading as="h3" lineHeight={10} mb={10} fontSize="32px" />,
                  span: <Heading as="span" color="violet.500" lineHeight={10} fontSize="32px" />,
                  br: <br />,
                }}
              />

              <Text fontFamily="heading" m={0}>
                {t('landing.eventExpoContent.sponsorsPlatform')}
              </Text>
              <Text fontFamily="heading" m={0}>
                {t('landing.eventExpoContent.liveEvents')}
              </Text>
            </Box>

            <Box
              flex={1}
              mt={{ base: 10, md: 0 }}
              ml={{ base: 0, md: '50px' }}
              maxW={{ base: '350px', md: '390px', lg: '510px' }}
            >
              <Sponsors />
            </Box>
          </Fragment>
        );

      default:
        return '';
    }
  };

  return (
    <Flex flexDir={{ base: 'column', md: 'row' }} justifyContent="space-around" maxW="990px" m="0 auto">
      {renderTabContent()}
    </Flex>
  );
};
